export default __webpack_public_path__ + "static/08-b00acbf6fac86975be33b69628e34be9.jpg";